import classes from './TickerSeparator.module.css';

export const TickerSeparator = ({visible}) => {
	if(!visible) {
		return (
			<span></span>
		);
	}
    return <div className={ classes.separator }>,</div>;
}